'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

require('../../src/styles/external.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SpecialistTopNavHeader = function SpecialistTopNavHeader(props) {
    var onClick = props.onClick,
        active = props.active,
        header = props.header;

    return _react2.default.createElement(
        'a',
        { onClick: onClick, className: _style2.default.headings },
        _react2.default.createElement(
            'span',
            { className: active ? _style2.default.activeSpecialist : _style2.default.notActiveSpecialist },
            header
        )
    );
};

SpecialistTopNavHeader.propTypes = {
    onClick: require('react').PropTypes.func.isRequired,
    active: require('react').PropTypes.bool.isRequired,
    header: require('react').PropTypes.string.isRequired
};
SpecialistTopNavHeader.displayName = 'SpecialistTopNavHeader';

SpecialistTopNavHeader.defaultProps = {
    onClick: function onClick() {},
    onHover: function onHover() {},
    active: false
};

exports.default = (0, _reactIntl.injectIntl)(SpecialistTopNavHeader);


// WEBPACK FOOTER //
// ./components/profile-right-section/lib/components/specialist-top-nav-header.js